module.exports = __webpack_public_path__ + "img/20200613_094419.326a5f77.jpg";